import Ink from "@frog/source/utility/integration/Ink.js"
import Stage from "@frog/source/models/Stage.js"
import Navigation from "@frog/source/models/admin/Navigation.js"
import Step from "@frog/source/models/Step.js"

const VALUE_BETWEEN_PARENTHESES = /\(([^)]+)\)/

export default function InkDialogue(knotname, stage) {
    const dialogues = Ink.loadDialogue(knotname)
    // console.log(knotname, dialogues)
    if(dialogues.length == 0) return []

    const steps = dialogues.map((dialogue) => {
        return Step.instantiate({
            "type": "StartDialogue",
            "alphastage": stage,
            "deltastages": [
                {
                    "mark": 0,
                    "dialogue": dialogue,
                }
            ]
        })
    }).concat([
        Step.instantiate({
            "type": "KillDialogue",
            "alphastage": stage,
            "deltastages": [
                {
                    "mark": 0,
                    "dialogue": undefined,
                }
            ]
        })
    ])

    return steps
}
